import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowLeft } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_health-portal-129/artifacts/t64300ho_SH%20Logo.png";

const LandingPageHeader = ({ accentColor = '#0066b3', subtitle = '' }) => {
  return (
    <nav className="sticky top-0 z-50 bg-white shadow-md" data-testid="landing-page-header">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Left - Logo & Back */}
          <div className="flex items-center gap-4">
            <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-testid="header-home-link">
              <img src={LOGO_URL} alt="Sakthi Hospital" className="h-11 w-auto object-contain" />
            </Link>
            {subtitle && (
              <>
                <div className="hidden sm:block w-px h-8 bg-gray-200"></div>
                <span className="hidden sm:block text-sm font-semibold" style={{ color: accentColor }}>{subtitle}</span>
              </>
            )}
          </div>

          {/* Right - CTA */}
          <div className="flex items-center gap-3">
            <Link
              to="/"
              className="hidden md:flex items-center gap-1.5 text-sm font-medium text-[#5a6b7c] hover:text-[#0f172a] transition-colors"
              data-testid="header-back-home"
            >
              <ArrowLeft size={16} />
              Home
            </Link>
            <a
              href="tel:+919840264444"
              className="flex items-center gap-2 px-4 py-2 rounded-lg font-semibold text-sm text-white transition-colors shadow-sm"
              style={{ backgroundColor: accentColor }}
              data-testid="header-call-btn"
            >
              <Phone size={15} className="animate-pulse" />
              <span className="hidden sm:inline">+91 98402 64444</span>
              <span className="sm:hidden">Call</span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default LandingPageHeader;
